import { __decorate, __metadata } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import BaseButton from '~/utils/base/BaseButton';
let ButtonCreate = class ButtonCreate extends BaseButton {
    mini;
    get computedIcon() {
        return this.$slots.icon ? null : this.icon || this.$icons.create;
    }
};
__decorate([
    Prop({
        default: 'success',
        type: String
    }),
    __metadata("design:type", String)
], ButtonCreate.prototype, "color", void 0);
__decorate([
    Prop({
        default: false,
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], ButtonCreate.prototype, "mini", void 0);
ButtonCreate = __decorate([
    Component
], ButtonCreate);
export default ButtonCreate;
